import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Banner from './banner/index.vue';
    import Content from './content/index.vue';
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top),
    _createVNode(Banner),
    _createVNode(Content),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})